/**
 * @generated SignedSource<<00a08d7ffeb55b106c695dadcc48f891>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueFormElements_templateElements$data = {
  readonly elements: ReadonlyArray<{
    readonly __typename: "IssueFormElementCheckboxes";
    readonly checkboxOptions: ReadonlyArray<{
      readonly label: string;
      readonly labelHTML: string;
      readonly required: boolean | null | undefined;
    }>;
    readonly descriptionHTML: string | null | undefined;
    readonly itemId: string | null | undefined;
    readonly label: string;
  } | {
    readonly __typename: "IssueFormElementDropdown";
    readonly defaultOptionIndex: number | null | undefined;
    readonly descriptionHTML: string | null | undefined;
    readonly itemId: string | null | undefined;
    readonly label: string;
    readonly multiple: boolean | null | undefined;
    readonly options: ReadonlyArray<string>;
    readonly required: boolean | null | undefined;
  } | {
    readonly __typename: "IssueFormElementInput";
    readonly descriptionHTML: string | null | undefined;
    readonly itemId: string | null | undefined;
    readonly label: string;
    readonly placeholder: string | null | undefined;
    readonly required: boolean | null | undefined;
    readonly value: string | null | undefined;
  } | {
    readonly __typename: "IssueFormElementMarkdown";
    readonly contentHTML: string;
  } | {
    readonly __typename: "IssueFormElementTextarea";
    readonly descriptionHTML: string | null | undefined;
    readonly itemId: string | null | undefined;
    readonly label: string;
    readonly placeholder: string | null | undefined;
    readonly render: string | null | undefined;
    readonly required: boolean | null | undefined;
    readonly value: string | null | undefined;
  } | {
    readonly __typename: "IssueFormElementUpload";
    readonly accept: string | null | undefined;
    readonly descriptionHTML: string | null | undefined;
    readonly itemId: string | null | undefined;
    readonly label: string;
    readonly required: boolean | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly " $fragmentType": "IssueFormElements_templateElements";
};
export type IssueFormElements_templateElements$key = {
  readonly " $data"?: IssueFormElements_templateElements$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFormElements_templateElements">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueFormElements_templateElements"
};

(node as any).hash = "d96aa980f56e8d29253f1239ebaa425e";

export default node;
